import { useState, useEffect } from 'react';

const TimeInputFocusController = ({
  children
}) => {
  const [focus, setFocus] = useState(undefined);
  let blurTimeout;

  // clear timeout on unmount
  useEffect(() => () => {
    clearBlurTimeout();
  });
  const clearBlurTimeout = () => {
    if (blurTimeout) {
      clearTimeout(blurTimeout);
    }
  };
  const focusNext = () => {
    if (focus === 'hour') {
      setFocus('minute');
    } else if (focus === 'minute') {
      setFocus('meridiem');
    }
  };
  const focusPrevious = () => {
    if (focus === 'meridiem') {
      setFocus('minute');
    } else if (focus === 'minute') {
      setFocus('hour');
    }
  };
  const onFocusHour = () => {
    clearBlurTimeout();
    setFocus('hour');
  };
  const onFocusMinute = () => {
    clearBlurTimeout();
    setFocus('minute');
  };
  const onFocusMeridiem = () => {
    clearBlurTimeout();
    setFocus('meridiem');
  };
  const onBlur = () => {
    clearBlurTimeout();

    /*
     * we want to transactional-ize the state update because we get a blur before each focus,
     * but we don't want to send a state with a empty focus.
     */
    blurTimeout = setTimeout(() => {
      setFocus(undefined);
    }, 0);
  };
  return children({
    focus,
    focusNext,
    focusPrevious,
    onFocusHour,
    onFocusMinute,
    onFocusMeridiem,
    onBlur
  });
};

export { TimeInputFocusController as T };
//# sourceMappingURL=CustomTimeInputFocusController-D2w6Gs_W.js.map
